import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CheckCircle2Icon, ClockIcon, ZapIcon } from 'lucide-react';
export function BeforeAfter() {
  return <section className="py-32 bg-black relative border-b border-white/5" data-id="element-19">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-20">
        <div className="text-center mb-20" data-id="element-21">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl text-offwhite tracking-tight leading-[1.05]" data-id="element-22">
            The difference is <span className="text-gold" data-id="element-23">night and day.</span>
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-24">
          {/* Before */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-black-charcoal border border-red-500/20 rounded-2xl p-8 relative overflow-hidden" data-id="element-25">
            <div className="absolute top-0 left-0 w-full h-1 bg-red-500/20" data-id="element-26" />
            <div className="flex items-center gap-3 mb-8" data-id="element-27">
              <XCircleIcon className="w-6 h-6 text-red-400" data-id="element-28" />
              <h3 className="font-display font-bold text-2xl text-offwhite uppercase tracking-tight" data-id="element-29">
                Without Prompts
              </h3>
            </div>

            <ul className="space-y-6" data-id="element-30">
              <li className="flex items-start gap-4" data-id="element-31">
                <ClockIcon className="w-5 h-5 text-muted shrink-0 mt-0.5" data-id="element-32" />
                <div data-id="element-33">
                  <p className="font-bold text-offwhite mb-1" data-id="element-34">3 Hours Wasted</p>
                  <p className="text-sm text-muted" data-id="element-35">
                    Staring at a blank screen trying to figure out what to
                    write.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-36">
                <div className="w-5 h-5 rounded-full border border-muted flex items-center justify-center shrink-0 mt-0.5 text-[10px] text-muted" data-id="element-37">
                  ?
                </div>
                <div data-id="element-38">
                  <p className="font-bold text-offwhite mb-1" data-id="element-39">
                    Vague Instructions
                  </p>
                  <p className="text-sm text-muted" data-id="element-40">
                    "Write an email about my new product."
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-41">
                <div className="w-5 h-5 rounded-full border border-muted flex items-center justify-center shrink-0 mt-0.5 text-[10px] text-muted" data-id="element-42">
                  !
                </div>
                <div data-id="element-43">
                  <p className="font-bold text-offwhite mb-1" data-id="element-44">Generic Output</p>
                  <p className="text-sm text-muted" data-id="element-45">
                    Robotic text that sounds like everyone else and doesn't
                    convert.
                  </p>
                </div>
              </li>
            </ul>
          </motion.div>

          {/* After */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-black-light border border-gold/30 rounded-2xl p-8 relative overflow-hidden shadow-gold-glow" data-id="element-46">
            <div className="absolute top-0 left-0 w-full h-1 bg-gold" data-id="element-47" />
            <div className="flex items-center gap-3 mb-8" data-id="element-48">
              <CheckCircle2Icon className="w-6 h-6 text-gold" data-id="element-49" />
              <h3 className="font-display font-bold text-2xl text-offwhite uppercase tracking-tight" data-id="element-50">
                With Our Prompts
              </h3>
            </div>

            <ul className="space-y-6" data-id="element-51">
              <li className="flex items-start gap-4" data-id="element-52">
                <ZapIcon className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-53" />
                <div data-id="element-54">
                  <p className="font-bold text-offwhite mb-1" data-id="element-55">
                    2 Minutes Total
                  </p>
                  <p className="text-sm text-muted" data-id="element-56">
                    Copy, paste, fill in the blanks, and you're done.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-57">
                <div className="w-5 h-5 rounded-full border border-gold flex items-center justify-center shrink-0 mt-0.5 text-[10px] text-gold font-bold" data-id="element-58">
                  ✓
                </div>
                <div data-id="element-59">
                  <p className="font-bold text-offwhite mb-1" data-id="element-60">
                    Expert Engineering
                  </p>
                  <p className="text-sm text-muted" data-id="element-61">
                    Prompts built with proven frameworks (PAS, AIDA, etc).
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-62">
                <div className="w-5 h-5 rounded-full border border-gold flex items-center justify-center shrink-0 mt-0.5 text-[10px] text-gold font-bold" data-id="element-63">
                  $
                </div>
                <div data-id="element-64">
                  <p className="font-bold text-offwhite mb-1" data-id="element-65">
                    High-Converting Output
                  </p>
                  <p className="text-sm text-muted" data-id="element-66">
                    Professional, human-sounding copy ready to publish.
                  </p>
                </div>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}